<template>
  <div>
    <!-- Media -->
    <b-media class="mb-3">
      <template #aside>
        <!-- :src="userData.avatar"
          :text="avatarText(userData.fullName)"
          :variant="`light-${resolveUserRoleVariant(userData.role)}`" -->
        <b-avatar ref="previewEl" size="90px" rounded />
      </template>
      <h4 class="mb-1">
        ชื่อร้านค้า :
      </h4>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-group>
            <b-form-input id="username" />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="d-flex flex-wrap">
        <b-button variant="primary" @click="$refs.refInputEl.click()">
          <input
            ref="refInputEl"
            type="file"
            class="d-none"
            @input="inputImageRenderer"
          />
          <span class="d-none d-sm-inline">Upload</span>
          <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
        </b-button>
        <b-button variant="outline-secondary" class="ml-1">
          <span class="d-none d-sm-inline">Remove</span>
          <feather-icon icon="TrashIcon" class="d-inline d-sm-none" />
        </b-button>
      </div>
    </b-media>

    <!-- User Info: Input Fields -->
    <b-form>
      <b-row>
        <b-col cols="12" class="d-flex mb-1">
          <feather-icon icon="UserIcon" size="19" />
          <h4 class="mb-0 ml-50">
            ข้อมูลส่วนตัว
          </h4>
        </b-col>
        <!-- Field: Username -->
        <!-- <b-col cols="12" md="4">
          <b-form-group label="เลขบัตรประจำตัวประชาชน" label-for="username">
            <b-form-input id="username" />
          </b-form-group>
        </b-col> -->

        <b-col cols="12" md="4">
          <b-form-group label="Username" label-for="username">
            <b-form-input id="username" v-model="userData.userName" />
          </b-form-group>
        </b-col>

        <!-- Field: Full Name -->
        <b-col cols="12" md="4">
          <b-form-group label="Password" label-for="password">
            <b-form-input id="password" v-model="userData.password" />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4"> </b-col>

        <!-- Field: Status -->
        <b-col cols="12" md="4">
          <b-form-group label="คำนำหน้านาม" label-for="user-status">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              :reduce="(val) => val.value"
              :clearable="false"
              input-id="user-status"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Email -->
        <b-col cols="12" md="4">
          <b-form-group label="ชื่อ" label-for="first-name">
            <b-form-input id="first-name" v-model="userData.firstName" />
          </b-form-group>
        </b-col>

        <!-- Field: Email -->
        <b-col cols="12" md="4">
          <b-form-group label="นามสกุล" label-for="last-name">
            <b-form-input id="last-name" v-model="userData.lastName" />
          </b-form-group>
        </b-col>

        <!-- Field: Gender -->
        <!-- <b-col cols="12" md="6" lg="4">
          <b-form-group label="เพศ" label-for="gender" label-class="mb-1">
            <b-form-radio-group
              id="gender"
              :options="genderOptions"
              value="male"
            />
          </b-form-group>
        </b-col> -->

        <!-- Field: Email -->
        <!-- <b-col cols="12" md="4">
          <b-form-group label="ชื่อเล่น" label-for="email">
            <b-form-input id="email" type="email" />
          </b-form-group>
        </b-col> -->

        <!-- Field: Birth Date -->
        <!-- <b-col cols="12" md="4">
          <b-form-group label="วัน / เดือน / ปี" label-for="birth-date">
            <flat-pickr
              class="form-control"
              :config="{ dateFormat: 'Y-m-d' }"
              placeholder="YYYY-MM-DD"
              v-model="dob"
            />
          </b-form-group>
        </b-col> -->
      </b-row>
    </b-form>

    <!-- Header: Personal Info -->
    <div class="d-flex mt-2">
      <feather-icon icon="MapPinIcon" size="19" />
      <h4 class="mb-0 ml-50">
        ข้อมูลการติดต่อ
      </h4>
    </div>

    <!-- Form: Personal Info Form -->
    <b-form class="mt-1">
      <b-row>
        <!-- Field: Mobile -->
        <b-col cols="12" md="6" lg="6">
          <b-form-group label="เบอร์โทรศัพท์" label-for="mobile">
            <b-form-input id="mobile" v-model="userData.phoneMobile" />
          </b-form-group>
        </b-col>

        <!-- Field: Email -->
        <b-col cols="12" md="6" lg="6">
          <b-form-group label="อีเมล" label-for="email">
            <b-form-input id="email" type="email" v-model="userData.email1" />
          </b-form-group>
        </b-col>

        <!-- Field: Website -->
        <b-col cols="12" md="12" lg="12">
          <b-form-group label="ที่อยู่" label-for="website">
            <b-form-input id="website" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <b-button
      variant="primary"
      class="mb-1 mb-sm-0 mr-0 mr-sm-1"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
      @click="handlerAddOrUpdate"
    >
      Save
    </b-button>
    <b-button
      variant="outline-secondary"
      type="reset"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Reset
    </b-button>
  </div>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import useUsersList from "../members-list/useMembersList";
import flatPickr from "vue-flatpickr-component";
import store from "@/store";
export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BFormRadioGroup,
    BFormCheckboxGroup,
    vSelect,
    flatPickr,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dob: null,
    };
  },
  setup(props) {
    const { resolveUserRoleVariant } = useUsersList();

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ];

    const permissionsData = [
      {
        module: "Admin",
        read: true,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: "Staff",
        read: false,
        write: true,
        create: false,
        delete: false,
      },
      {
        module: "Author",
        read: true,
        write: false,
        create: true,
        delete: false,
      },
      {
        module: "Contributor",
        read: false,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: "User",
        read: false,
        write: false,
        create: false,
        delete: true,
      },
    ];

    const languageOptions = [
      "English",
      "Spanish",
      "French",
      "Russian",
      "German",
      "Arabic",
      "Sanskrit",
    ];

    const genderOptions = [
      { text: "ชาย", value: "male" },
      { text: "หญิง", value: "female" },
    ];

    const contactOptionsOptions = ["Email", "Message", "Phone"];

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        // eslint-disable-next-line no-param-reassign
        props.userData.avatar = base64;
      }
    );

    return {
      resolveUserRoleVariant,
      avatarText,
      roleOptions,
      statusOptions,
      permissionsData,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      languageOptions,
      genderOptions,
      contactOptionsOptions,
    };
  },
  methods: {
    handlerAddOrUpdate() {
      // mapModel Data
      store
        .dispatch("user/addUser", this.userData)
        .then((response) => {
          console.log("resUserAdd", response);
        })
        .catch((error) => {
          console.log("err", error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
